import {put, takeLatest, call} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {get} from 'lodash';
import {transformCorpStructure} from '@app/utils/helpers';
import {
  fetchCorporateStructureRequest,
  fetchCorporateStructureSuccess,
  fetchCorporateStructureError,
} from './index';
import {fetchCorporateStructure} from './api';

export const sagaActions = {
  FETCH_CORPORATE_STRUCTURE: 'FETCH_CORPORATE_STRUCTURE',
};

function* fetchCorporateStructureSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchCorporateStructureRequest());
    const result = yield call(fetchCorporateStructure, values);
    if (!result.error) {
      const data = yield call(transformCorpStructure, result.data);
      yield put(fetchCorporateStructureSuccess(data));
    } else {
      yield put(fetchCorporateStructureSuccess([]));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchCorporateStructureError(message));
    } else {
      toast.error(e.error);
      yield put(fetchCorporateStructureError(e.error));
    }
  }
}

function* rootSagas() {
  yield takeLatest(
    sagaActions.FETCH_CORPORATE_STRUCTURE,
    fetchCorporateStructureSaga
  );
}

export default rootSagas;
